import React from 'react'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'

export const ScheduleForm = ({ onSubmit, addScheduleModalData, syl }) => {
  const [selectedExam, setSelectedExam] = React.useState(null)
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()

  const submit = (data) => {
    onSubmit(data, selectedExam, syl, addScheduleModalData)
  }

  const examsDep = JSON.parse(sessionStorage.getItem('auth')).state.dependeciesFormAPIS.exams || []
  return (
    <form onSubmit={handleSubmit(submit)} className="trtui-row trtui-g-2">
      <div className={`trtui-col-md-3`}>
        <label className="trtui-form-label">Exam</label>
        <select
          className={`trtui-form-control trtui-mb-2`}
          style={{
            paddingRight: 'calc(1.5em + 1rem)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right calc(0.375em + 0.25rem) center',
            backgroundSize: 'calc(0.75em + 0.5rem) calc(0.75em + 0.5rem)',
          }}
          id={'exams'}
          {...register('exams', {
            required: 'Exam name is required',
          })}
          onChange={(e) => setSelectedExam(e.target.value)}
        >
          <option value={''}>Select Exam</option>
          {examsDep.formData?.map((exms, exmsInd) => (
            <option key={exmsInd} value={JSON.stringify(exms)}>
              {exms.examName}
            </option>
          ))}
        </select>
        {errors['exams'] && <div className="trtui-invalid-feedback">{errors['exams'].message}</div>}
      </div>
      <div className={`trtui-col-md-3`}>
        <label className="trtui-form-label">Date</label>
        <input
          className={`trtui-form-control ${errors['examDate'] && 'trtui-is-invalid'}`}
          type="date"
          {...register('examDate', {
            required: 'Exam date is required',
          })}
        />
        {errors['examDate'] && (
          <div className="trtui-invalid-feedback">{errors['examDate'].message}</div>
        )}
      </div>
      <div className={`trtui-col-md-2`}>
        <label className="trtui-form-label">Start Time</label>
        <input
          className={`trtui-form-control ${errors['examStartTime'] && 'trtui-is-invalid'}`}
          type="time"
          id={'examStartTime'}
          {...register('examStartTime', {
            required: 'Start time is required',
          })}
        />
        {errors['examStartTime'] && (
          <div className="trtui-invalid-feedback">{errors['examStartTime'].message}</div>
        )}
      </div>
      <div className={`trtui-col-md-2`}>
        <label className="trtui-form-label">End Time</label>
        <input
          className={`trtui-form-control ${errors['examEndTime'] && 'trtui-is-invalid'}`}
          type="time"
          id={'examEndTime'}
          {...register('examEndTime', {
            required: 'End time is required',
          })}
        />
        {errors['examEndTime'] && (
          <div className="trtui-invalid-feedback">{errors['examEndTime'].message}</div>
        )}
      </div>
      <div className={`trtui-col-md-2`}>
        <button
          className="trtui-btn trtui-btn-success trtui-btn-icon trtui-btn-sm"
          style={{ marginTop: '2.1rem' }}
        >
          <i className="ri ri-add-line" />
        </button>
      </div>
    </form>
  )
}

ScheduleForm.propTypes = {
  onSubmit: PropTypes.func,
  addScheduleModalData: PropTypes.object,
  syl: PropTypes.object,
}
